export let DisplayMode;

(function (DisplayMode) {
  DisplayMode["Placeholder"] = "placeholder";
  DisplayMode["Label"] = "label";
})(DisplayMode || (DisplayMode = {}));